import { createContext } from 'react'
export const SidebarToggleContext = createContext()
export const SidebarToggleProvider = SidebarToggleContext.Provider
